/* eslint-disable max-classes-per-file */
import AbstractSubject from '@naturehouse/nh-essentials/lib/architecture/ObserverPattern';
import type { Observer } from '@naturehouse/nh-essentials/lib/architecture/ObserverPattern';

type Constructor<T = object> = new (...args: any[]) => T;

interface Subject {
    attach(o: Observer): void;
    detach(o: Observer): void;
    notify(...args: any[]): void;
}

type SubjectConstructor<TBase extends Constructor<HTMLElement>> = new (
    ...args: ConstructorParameters<TBase>
) => InstanceType<TBase> & Subject;

function SubjectMixin<TBase extends Constructor<HTMLElement>>(
    Base: TBase
): SubjectConstructor<TBase> {
    class DefaultSubject extends AbstractSubject {
        override notify(...args: any[]): void {
            // @ts-ignore
            this.observers.forEach((observer) => observer.update(...args));
        }
    }

    class SubjectElement extends Base {
        readonly #subject = new DefaultSubject();

        public attach(o: Observer): void {
            this.#subject.attach(o);
        }

        public detach(o: Observer): void {
            this.#subject.detach(o);
        }

        public notify(...args: any[]): void {
            this.#subject.notify(...args);
        }
    }

    return SubjectElement as unknown as SubjectConstructor<TBase>;
}

export default SubjectMixin;

export { Constructor, SubjectConstructor };
